import AuditLogs from '@/views/logs/views/AuditLogs.vue';

export default [
  {
    path: '/logs/audit-logs/',
    component: AuditLogs,
    //component: () => import('@/views/logs/views/AuditLogs.vue'),
    meta: { 
    	requiresPermission: 'audit-logs', 
    	requiresSubscription: 'audit-logs',
    	featureName: 'Audit Logs' 
    } 
    //meta: { requiresPermission: 'sms-settings'} 
  }
];
